import { TimelineItemCategoryEnum } from "web_myplann/Infrastructure/Api/Api";

const BASE_PREVIEW_CATEGORIES: TimelineItemCategoryEnum[] = [
	TimelineItemCategoryEnum.Activity,
	TimelineItemCategoryEnum.Contract,
	TimelineItemCategoryEnum.ClientAction,
];

export interface RecentPreviewRights {
	hasNotificationCenterRight: boolean;
	hasRemindersRight: boolean;
	hasDocumentsFeature: boolean;
}

export const getRecentPreviewCategories = ({
	hasNotificationCenterRight,
	hasRemindersRight,
	hasDocumentsFeature,
}: RecentPreviewRights): TimelineItemCategoryEnum[] => [
	...BASE_PREVIEW_CATEGORIES,
	...(hasNotificationCenterRight && hasRemindersRight
		? [TimelineItemCategoryEnum.Reminder]
		: []),
	...(hasNotificationCenterRight && hasDocumentsFeature
		? [TimelineItemCategoryEnum.IdentificationDocument]
		: []),
];
